import { z } from 'zod';

export const insightsSummarySchema = z.object({
  groupsInScope: z.number(),
  entitiesInScope: z.number().default(0),
  tracksInScope: z.number(),
  /** Share of passing checks across all levels, mandatory and recommended. */
  averageCompliance: z.number(),
  /** Share of passing checks across mandatory levels only. */
  mandatoryCompliance: z.number(),
});

export const insightsTrackRowSchema = z.object({
  id: z.string(),
  trackId: z.string(),
  trackName: z.string(),
  ownerEntityRef: z.string(),
  checkCount: z.number(),
  entityCount: z.number(),
  compliancePercentage: z.number(),
});

export const insightsTracksResponseSchema = z.object({
  summary: insightsSummarySchema,
  rows: z.array(insightsTrackRowSchema),
});

export type InsightsTrackRow = z.infer<typeof insightsTrackRowSchema>;
export type InsightsTracksResponse = z.infer<
  typeof insightsTracksResponseSchema
>;
